import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
	selector: 'app-notification-option',
	templateUrl: './notification-option.component.html',
	styleUrls: ['./notification-option.component.scss'],
})
export class NotificationOptionComponent {
	@Input() icon: string;
	@Input() text: string;
	@Input() form: UntypedFormGroup;
	@Input() control: string;
	@Input() tooltip: string = undefined;
	@Input() position: string | null = null;
	@Input() disabled: boolean;
}
